import type { ExtractedMessages } from '@Infra/FetchLib/ApiError/extractMessages';

export type DocumentTemplatesFetchFailedAction = {
	type: 'DOCUMENT_TEMPLATES_FETCH_FAILED';
	payload: ExtractedMessages;
};

export default (payload: ExtractedMessages): DocumentTemplatesFetchFailedAction => ({
	type: 'DOCUMENT_TEMPLATES_FETCH_FAILED',
	payload,
});
